/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for marking notifications as read
 * @export
 * @interface MarkNotificationsAsReadResponse
 */
export interface MarkNotificationsAsReadResponse {
    /**
     * Number of notifications marked as read
     * @type {number}
     * @memberof MarkNotificationsAsReadResponse
     */
    count: number;
}

/**
 * Check if a given object implements the MarkNotificationsAsReadResponse interface.
 */
export function instanceOfMarkNotificationsAsReadResponse(value: object): value is MarkNotificationsAsReadResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function MarkNotificationsAsReadResponseFromJSON(json: any): MarkNotificationsAsReadResponse {
    return MarkNotificationsAsReadResponseFromJSONTyped(json, false);
}

export function MarkNotificationsAsReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkNotificationsAsReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function MarkNotificationsAsReadResponseToJSON(json: any): MarkNotificationsAsReadResponse {
    return MarkNotificationsAsReadResponseToJSONTyped(json, false);
}

export function MarkNotificationsAsReadResponseToJSONTyped(value?: MarkNotificationsAsReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

